import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { getResetStateMutation } from "@/store/helpers/helpers";

const getDefaultState = () => ({
  videoCallInviteCreationStatus: null,
  receivedInvites: [],
  sentInvites: [],
  sentInvitesUsersMap: {
    TABLE_MOVEMENT: {},
    VIDEO_CALL: {}
  },
  displayingReceivedInvites: {}
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    resetState: getResetStateMutation(getDefaultState)
  },
  actions,
  getters
};
